import { z } from 'zod'
import { CreateAndUpdateAlertSettingsDto } from '../../../domain/dtos/CreateAndUpdateAlertSettings.dto'
import { CreateLinkedMonitoredAreaDto } from '../../../domain/dtos/CreateLinkedMonitoredArea.dto'

export const CreateAlertSettingsSchema = z.object({
	description: z.string().min(1),
	monitoredAreas: z
		.array(z.uuid({ message: 'id da área monitorada vinculada precisa ser informado' }))
		.nonempty(),
	buffer: z.number().nonnegative(),
	minDetectionConfidence: z.number().min(0).max(100),
})

export const CreateAlertSettingsParser = CreateAlertSettingsSchema.transform((data) => {
	return {
		areas_monitoradas_vinculadas: data.monitoredAreas.map((id) => {
			return { id_area_monitorada_vinculada: id } as unknown as CreateLinkedMonitoredAreaDto
		}),
		descricao: data.description,
		distancia_buffer: data.buffer * 1000,
		porcentagem_confianca_minima: data.minDetectionConfidence,
	} as CreateAndUpdateAlertSettingsDto
})
